"use strict";

var _classCallCheck = require("/home/circleci/src/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/src/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connect = void 0;

var ConnectLinks_1 = require("./ConnectLinks");

var Connect = /*#__PURE__*/function () {
  function Connect() {
    _classCallCheck(this, Connect);

    this.distance = 80;
    this.links = new ConnectLinks_1.ConnectLinks();
    this.radius = 60;
  }

  _createClass(Connect, [{
    key: "line_linked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "lineLinked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = data.distance;
      }

      this.links.load((_b = (_a = data.links) !== null && _a !== void 0 ? _a : data.lineLinked) !== null && _b !== void 0 ? _b : data.line_linked);

      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }]);

  return Connect;
}();

exports.Connect = Connect;